﻿import DefaultApp from './defaultApp';
import mixin from './mixin';
import { useVuelidate } from '@vuelidate/core';
import { required, email, sameAs, requiredIf } from '@vuelidate/validators';
const axios = require('axios');

const passwordApp = {
    ...DefaultApp,
    mixins: [mixin],
    setup() {
        return { v$: useVuelidate() }
    },
    data() {
        return {
            ...DefaultApp.data(),
            accessToken: '',
            apiPasswordMail: '',
            apiCheckPassword: '',
            apiChangePassword: '',
            apiGetUser: '',
            tokenNotFoundCheck: '',
            tokenExpiredCheck: '',
            memberNotFoundCheck: '',
            passwordIncorrectCheck: '',
            passwordFormatCheck: '',
            passwordReuseCheck: '',
            successCheck: '',
            emailFormData: new FormData(),
            passwordFormData: new FormData(),
            accessFormData: new FormData(),
            showEmailSend: false,
            userNotFound: false,
            username: '',
            loginLink: '',
            newPassword: '',
            confirmPassword: '',
            data: {
                typeAlias: 'Success'
            },
            userData: {
                member: {
                    email: '',
                    fullname: '',
                    lastLoginAt: ''
                },
                typeAlias: 'Success'
            },
            newPasswordType: 'password',
            confirmPasswordType: 'password',
            passwordInvalid: false,
            passwordRulesReport: [],
            passwordUsedBefore: false,
            changePasswordSuccess: false
        }
    },
    validations() {
        if (this.accessToken === '') {
            return {
                username: {
                    required,
                    email
                }
            }
        } else if (!this.userNotFound){
            return {
                newPassword: {
                    required
                },
                confirmPassword: {
                    required,
                    sameAs: sameAs(this.newPassword)
                }
            }
        }
    },
    computed: {
        passwordCheck() {
            let hasOneLetterVal = false;
            let hasOneCapitalVal = false;
            let hasOneNumberVal = false;
            let hasEightCharsVal = false;
            let hasOneSpecialVal = false;
            let hasNoForbiddenWordsVal = false;
            if (this.passwordRulesReport.length) {
                hasOneLetterVal = this.passwordRulesReport.find(r => r.passwordRuleAlias === 'Min1Letter').success;
                hasOneCapitalVal = this.passwordRulesReport.find(r => r.passwordRuleAlias === 'Min1Capital').success;
                hasOneNumberVal = this.passwordRulesReport.find(r => r.passwordRuleAlias === 'Min1Digit').success;
                hasEightCharsVal = this.passwordRulesReport.find(r => r.passwordRuleAlias === 'Min8Char').success;
                hasOneSpecialVal = this.passwordRulesReport.find(r => r.passwordRuleAlias === 'Min1SpecialChar').success;
                hasNoForbiddenWordsVal = this.passwordRulesReport.find(r => r.passwordRuleAlias === 'NoForbiddenWords').success;
            }
            return {
                hasOneLetter: hasOneLetterVal,
                hasOneCapital: hasOneCapitalVal,
                hasOneNumber: hasOneNumberVal,
                hasEightChars: hasEightCharsVal,
                hasOneSpecial: hasOneSpecialVal,
                hasNoForbiddenWords: hasNoForbiddenWordsVal
            }
        },
        allChecked() {
            return Object.keys(this.passwordCheck).every(c => this.passwordCheck[c])
        }
    },
    methods: {
        ...DefaultApp.methods,
        cancel(fields) {
            this.v$.$reset();
            fields.split(',').forEach(field => {
                this[field] = '';
            });
            window.location.href = this.loginLink;
        },
        togglePassword(type,obj) {
            if (type === 'password') {
                if (obj === 'newPassword') {
                    this.newPasswordType = 'text';
                } else {
                    this.confirmPasswordType = 'text';
                }
            } else {
                if (obj === 'newPassword') {
                    this.newPasswordType = 'password';
                } else {
                    this.confirmPasswordType = 'password';
                }
            }
        },
        resetToken() {
            this.accessToken = '';
            this.data.typeAlias = 'Success';
            window.history.replaceState(null, null, window.location.pathname);
        },
        async sendMail() {
            let valid = await this.v$.$validate();
            if (!valid) return
            this.emailFormData.set('username', this.username);
            const response = await this.fetchData(this.emailFormData, this.apiPasswordMail, 'post');
            if (response.status === 200) {
                this.data = response.data;
                if (this.data.typeAlias === 'Success') {
                    this.showEmailSend = true;
                }
            }
        },
        async submitPassword() {
            let valid = await this.v$.$validate();
            if (!valid) return
            this.passwordFormData.set('newpassword', this.newPassword);
            this.passwordFormData.set('confirmpassword', this.confirmPassword);
            this.passwordFormData.set('accesstoken', this.accessToken);
            const response = await this.fetchData(this.passwordFormData, this.apiChangePassword, 'put');
            if (response.status === 200) {
                this.data = response.data;
                if (this.data.typeAlias === 'Success') {
                    this.changePasswordSuccess = true;
                } else if (this.data.typeAlias === this.tokenNotFoundCheck || this.data.typeAlias === this.tokenExpiredCheck) {
                    this.userNotFound = true;
                } else if (this.data.typeAlias === this.passwordFormatCheck) {
                    this.passwordRulesReport = [];
                    this.passwordInvalid = true;
                } else if (this.data.typeAlias === this.passwordReuseCheck) {
                    this.passwordUsedBefore = true;
                }
            }
        }
    },
    created() {
        this.checkPassword = this.debounce(async (event) => {
            let pwData = {
                password: this.newPassword
            }
            const response = await this.fetchData(pwData, this.apiCheckPassword, 'post');
            if (response.status === 200) {
                this.passwordRulesReport = response.data.rulesReportReport;
            }
        });
    },
    async mounted() {
        if (this.$el.parentNode.dataset.login) this.loginLink = this.$el.parentNode.dataset.login;
        if (this.$el.parentNode.dataset.accesstoken) this.accessToken = this.$el.parentNode.dataset.accesstoken;
        if (this.$el.parentNode.dataset.apipasswordmail) this.apiPasswordMail = this.$el.parentNode.dataset.apipasswordmail;
        if (this.$el.parentNode.dataset.apicheckpassword) this.apiCheckPassword = this.$el.parentNode.dataset.apicheckpassword;
        if (this.$el.parentNode.dataset.apigetuser) this.apiGetUser = this.$el.parentNode.dataset.apigetuser;
        if (this.$el.parentNode.dataset.apichangepassword) this.apiChangePassword = this.$el.parentNode.dataset.apichangepassword;
        if (this.$el.parentNode.dataset.tokennotfound) this.tokenNotFoundCheck = this.$el.parentNode.dataset.tokennotfound;
        if (this.$el.parentNode.dataset.tokenexpired) this.tokenExpiredCheck = this.$el.parentNode.dataset.tokenexpired;
        if (this.$el.parentNode.dataset.membernotfound) this.memberNotFoundCheck = this.$el.parentNode.dataset.membernotfound;
        if (this.$el.parentNode.dataset.passwordincorrect) this.passwordIncorrectCheck = this.$el.parentNode.dataset.passwordincorrect;
        if (this.$el.parentNode.dataset.passwordformatissues) this.passwordFormatCheck = this.$el.parentNode.dataset.passwordformatissues;
        if (this.$el.parentNode.dataset.passwordreuseproblem) this.passwordReuseCheck = this.$el.parentNode.dataset.passwordreuseproblem;
        if (this.$el.parentNode.dataset.success) this.successCheck = this.$el.parentNode.dataset.success;
        if (this.accessToken !== '') {
            const response = await this.fetchData('', this.apiGetUser, 'get');
            if (response.status === 200) {
                this.userData = response.data;
                if (this.userData.typeAlias === 'UserNotFound') {
                    this.userNotFound = true;
                } else {
                    this.userNotFound = false;
                    this.username = this.userData.member.fullname;
                }
            }
        }
    }
};

export default passwordApp;